const env = process.env.NODE_ENV
const isProd = env === 'production'

export const baseApiUrl = isProd ? 'https://api.srtracking-uoi.com/' : 'http://localhost:6025/'
export const uploaderUrl = isProd ? 'https://upload.srtracking-uoi.com/' : 'http://localhost:6027/'

export const baseApiUrlDHL = 'https://wsbexpress.dhl.com/rest/sndpt/'

export const listUom = [
  {
    title: 'KG',
    value: 'kg',
    conversion: 0.001
  },
  {
    title: 'TON',
    value: 'ton',
    conversion: 1
  },
  {
    title: 'Paper Bag',
    value: 'paperbag',
    conversion: 0.025
  },
  {
    title: 'Jumbo Bag 800 Kg',
    value: 'jumbobag800',
    conversion: 0.8
  },
  {
    title: 'Jumbo Bag 1 Ton',
    value: 'jumbobag1000',
    conversion: 1
  }
]

export const listGanttChart = [
  {
    title: 'SR Create',
    value: 'srcreate'
  },
  {
    title: 'Prepare Sample',
    value: 'preparesample'
  },
  {
    title: 'Delivery',
    value: 'delivery'
  },
  {
    title: 'Received',
    value: 'received'
  },
  {
    title: 'Trial Date',
    value: 'trialdate'
  }
]